import styled, { keyframes } from 'styled-components';

export const Div = styled.div`
    position: absolute;
    width: calc(100%);
    height: calc(100%);
    background: transparent;
`;

export const OverlayContainer = styled.div`
    align-items: center;
    background-color: ${({ backgroundColor }) => backgroundColor};
    bottom: 2px;
    box-shadow: 0 0 0 2px ${({ borderColor }) => borderColor};
    display: flex;
    flex-direction: ${({ showStacked }) => (showStacked ? 'column' : 'row')};
    justify-content: center;
    left: 2px;
    position: absolute;
    right: 2px;
    top: 2px;
    z-index: 1;
`;

export const UserNameBackground = styled.div`
    display: flex;
    padding: ${({ hasLogo }) => (hasLogo ? '2px 6px' : '8px')};
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: 3px;
    -webkit-box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
    -moz-box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
    box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
`;

export const UserNameLogo = styled.img`
    width: 28px;
    height: 28px;
`;

export const UserNameText = styled.div`
    background-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ textColor }) => textColor};
    font-size: 13px;
    font-weight: 600;
    margin: auto;
`;

export const WaveContainer = styled.div`
    margin: 6px;
`;

const wave = keyframes`
    0%, 60%, 100% {
        transform: initial;
    }

    30% {
        transform: translateY(-8px);
    }
`;

export const WaveDot = styled.span`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 6px;
    background: ${({ color }) => color};
    animation: ${wave} 1.3s linear infinite;

    &:nth-child(2) {
        animation-delay: -1.1s;
    }

    &:nth-child(3) {
        animation-delay: -0.9s;
    }
`;

export const DropZoneBar = styled.div(({ theme, isVisible }) => ({
    height: isVisible ? 3 : 0,
    width: '100%',
    transition: 'height 0.1s linear',
    backgroundColor: theme.colors.primary300,
}));